module.exports = __webpack_public_path__ + "img/pdf.7b7c34df.svg";